import React, { Component } from 'react'
import { connect } from 'react-redux'
import ACSelector from './ACSelector'
import RoundSlider from '../roundSlider'
import { changeValue } from '../roundSlider'
import {
    ACPower, setTempOfAC, setFanSpeedToLow,
    setFanSpeedToMedium, setFanSpeedToHigh,
    setFanSpeedToAuto, ecoMode, decrementTemp,
    incrementTemp, fanSpeedID, setFanSpeedToggle,
    zoneName,
    CLICKED,
    EXIT,
    CMSPath
} from '../../../../config/constant'
import {
    sendCommand, setPowerSwitch, TempChange,
    sendACCommand, setSelectedZone, restoreValue, setSelectedAC, sendAcCommand, getInncomRoomControlData, setAcSelected
} from '../../../../action/roomControlAction'
import { roomThemeColorConfig } from '../../../JS/colorConfig'
import DefaultImage from '../../../../images/defaultAsset/bg_room_temp.png'
import { scrollUpEffect, scrollDownEffect, removeScrollDown } from '../scrollEffect';
import $ from 'jquery';
import { scrollToTop } from '../../../../JS/scrollToTop'
import {setGoHome} from '../../../action/homeAction'
import { sendAnalytics } from '../../../../action/homeAction'
import { calculateTimeDifference, getDefaultAnalyticsLabel } from '../../../JS/utility'
import { setFailScreen } from '../../../../action/action'

const UpArrow = ()=>{
    return <svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20" fill="none">
    <path d="M15.5 12.5L10.5 7.5L5.5 12.5" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
}

const DownArrow =()=>{
    return <svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20" fill="none">
    <path d="M5.5 7.5L10.5 12.5L15.5 7.5" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
}

class AcControl extends Component {

    constructor(props) {
        super(props)
        this.sliderObj = new RoundSlider();
        this.state = {
            powerON: 'ON',
            mode: null,
            isACSelected: false,
            goBackClicked: false,
            fanSpeed: null,
            currentACUnit: null,
            currentRoomTemp: null,
            currentACTemp: null,
            celciusMax: null,
            celciusMin: null,
            fahrenheitMin: null,
            fahrenheitMax: null,
            currentFanSpeed: null,
            widgetLaunchTime: new Date,
            widgetName: this.props.currentWidgets.displayName
        }

        this.appBodyPaddBottom = null;
        this.roomTempPaddingTop = null;
    }
    componentDidUpdate(preProps) {
        // this.updateState()
        // if (preProp.selectedZone !== this.props.selectedZone && this.props.selectedZone.zoneId)
        //     sliderInit()
        // if (this.props.powerSwitch !== preProps.powerSwitch) {
        //     this.setState({
        //         powerON: this.props.powerSwitch,
        //     })
        // }
        // if (his.props.selectedAC.fanSpeed !== preProps.currentFanSpeed) {
        //     // onControlClick(this.props.currentFanSpeed, "fanSpeed", this.props.menuColor);
        //     this.setState({
        //         fanSpeed: this.props.currentFanSpeed,
        //     })
        // }
        $("section#roomTemp").attr("style","padding-top: 0 !important")
        roomThemeColorConfig(this.props.menuColor);
    }

    callApiToSetTemp = () => {
        setTimeout(() => {
            this.props.sendAcCommand(
                "setTempOfAC", this.state.currentACTemp, `+${this.state.currentACUnit}`, this.props.selectedAC.HVACIdentifierKey, this.props.guestDetail,
                "unitSwitch", this.CommandCallBack, this.props.roomControlSpecificVersion
            );
        }, 50)
    }

    onValChange = (event, cb) => {
        let Temprature;
        // window.setTimeout(() => {
        let temp = parseInt(this.state.currentACTemp);
        let change = event.value - temp
        console.log("valChnage", event.value, change);
        // this.sliderObj.changeValue(22);
        // }, 1000);
        if (temp !== 999 &&
            this.props.selectedAC && this.state.powerON === "ON") {
            if (event.value > temp) {
                // for (let i = 1; i <= change; i++) {
                //     console.log("change", change);
                Temprature = temp + change
                console.log('Temprature**********',Temprature)
                // this.props.sendAcCommand(
                //     "setTempOfAC", Temprature, `+${this.state.currentACUnit}`, this.props.selectedAC.HVACIdentifierKey, this.props.guestDetail,
                //     "unitSwitch", this.CommandCallBack
                // );
                this.setState({
                    currentACTemp: Temprature
                })
                this.props.TempChange("inc", Temprature);
                // }
            } else {
                // for (let i = 1; change <= 0; i++) {
                Temprature = temp + change
                // this.props.sendAcCommand(
                //     "setTempOfAC", Temprature, `+${this.state.currentACUnit}`, this.props.selectedAC.HVACIdentifierKey, this.props.guestDetail,
                //     "unitSwitch", this.CommandCallBack
                // );
                change = change + 1;
                this.props.TempChange("dec", Temprature);
                this.setState({
                    currentACTemp: Temprature
                })
                // }
            }
        }

        if(cb)cb();
    }

    ResetTemp = (chnageType) => {
        console.log("call back", this.props.currentACTemp)
        let temp = this.props.currentACTemp

        // IF you want to see temprature change on API fail in real time uncomment below block.
        // if (chnageType === "inc") {
        //     temp = temp - 1
        //     this.props.TempChange("dec", temp);
        // } else {
        //     temp = temp + 1
        //     this.props.TempChange("inc", temp);
        // }

    }

    ACPowerSwitch = () => {
        if (this.props.selectedZone.zoneId) {
            if (this.state.powerON) {
                if (this.props.powerSwitch === "ON") {
                    console.log("ACPowerSwitch OFF");
                    this.setState({ powerON: "OFF" });
                } else {
                    console.log("ACPowerSwitch ON");
                    this.setState({ powerON: "ON" });
                }
                this.props.sendAcCommand(
                    ACPower, this.props.guestDetail, "power",
                    this.CommandCallBack, null, this.props.selectedZone.zoneId
                );
                //this.VDAApiCall();
            }
        }
    }

    ACUnitSwitch = () => {
        console.log('this.state.currentACUnit',this.state.currentACUnit)
        if (this.state.currentACUnit === 'F') {
            let temp = this.fahrenheitToCelsius(this.state.currentACTemp, true, this.state.celciusMin, this.state.celciusMax)
            let roomTemp = this.fahrenheitToCelsius(this.state.currentRoomTemp, false, this.state.celciusMin, this.state.celciusMax)

            if(this.props.configs.acUnitChangeViaServer){
                this.props.sendAcCommand(
                    "setDisplayTempUnitToCelcius", temp, null, this.props.selectedAC.HVACIdentifierKey, this.props.guestDetail,
                    "unitSwitch", this.CommandCallBack, this.props.roomControlSpecificVersion
                );
            }
                this.setState({ currentACTemp: temp, currentACUnit: "C", currentRoomTemp: roomTemp}) 
            // console.log('temp', temp)
        } 
        else {
            let temp = this.celsiusToFahrenheit(this.state.currentACTemp, true,this.state.fahrenheitMin,this.state.fahrenheitMax)
            let roomTemp = this.celsiusToFahrenheit(this.state.currentRoomTemp, false, this.state.fahrenheitMin, this.state.fahrenheitMax)

            if(this.props.configs.acUnitChangeViaServer){
                this.props.sendAcCommand(
                    "setDisplayTempUnitToFahrenheit", temp, null, this.props.selectedAC.HVACIdentifierKey, this.props.guestDetail,
                    "unitSwitch", this.CommandCallBack ,this.props.roomControlSpecificVersion
                );
            }
                this.setState({ currentACTemp: temp, currentACUnit: "F", currentRoomTemp: roomTemp})
            console.log('temp', temp )
        }
    }

    celsiusToFahrenheit = (temp, log=false, min, max) => {
        // if(this.state.currentACUnit === "fahrenheit"){
            let newTemp = ((temp * 1.8) + 32).toFixed(0);

            if(newTemp<min) newTemp=min;
            else if( newTemp>max) newTemp=max;

            if(log){
                console.log('temp, newTemp , AcUnit', temp, newTemp, this.state.currentACUnit)
            }
            return newTemp <= 32 ? 32 : newTemp >= 212 ? 212 : newTemp;
        // }else{
        //     return !temp ? 0 : temp;
        // }
    }

    fahrenheitToCelsius = (temp, log=false, min, max) => {
        // if(this.state.currentACUnit === "celsius"){
            let newTemp = ((temp - 32) * 0.5556).toFixed(0);
            if(newTemp<min) newTemp=min;
            else if( newTemp>max) newTemp=max;

            if(log){
                console.log('temp, newTemp , AcUnit', temp, newTemp, this.state.currentACUnit)
            }
            return newTemp <= 0 ? 0 : newTemp >= 100 ? 100 : newTemp;;
        // }else{
        //     return !temp ? 0 : temp;
        // }
        // console.log('that runs')
        // let value = (temp - 32) * 0.5556.toFixed(0);
        // console.log('value',value)
        // return value;
    }

    CommandCallBack = (section, status) => {
        // console.log("API callback")
        // if (section === "power") {
        //     if (status) {
        //         if (this.props.powerSwitch === "ON") {
        //             this.props.setPowerSwitch("OFF");
        //         } else {
        //             this.props.setPowerSwitch("ON");
        //         }
        //     } else {
        //         if (this.props.powerSwitch === "ON") {
        //             if (document.getElementById("power-switch"))
        //                 document.getElementById("power-switch").checked = true
        //             console.log("API faild with ON");
        //         } else {
        //             if (document.getElementById("power-switch"))
        //                 document.getElementById("power-switch").checked = false
        //             console.log("API faild with OFF");
        //         }
        //     }
        // } else if (section === "fanSpeed") {
        //     if (!status) {
        //         this.setState({ fanSpeed: this.props.currentFanSpeed });
        //         if (!this.props.currentFanSpeed) {
        //             // onControlClick(null, section, this.props.menuColor);
        //         }
        //     }
        // } else if (section === "ecoMode") {
        //     if (status) {
        //         this.props.setEcoMode(this.state.mode);
        //     } else {
        //         // this.setState({ mode: this.props.ecoMode });
        //     }
        // } else if (section === "unitSwitch") {
        //     if (status) {
        //         if (this.state.currentACUnit === "F") {
        //             this.setState({currentACUnit : "C" });
        //         } else {
        //             this.setState({currentACUnit : "F" });
        //         }
        //     } else {
        //         if (this.state.currentACUnit === "C") {
        //             if (document.getElementById("unit-switch"))
        //                 document.getElementById("unit-switch").checked = true
        //             console.log("API faild with ON");
        //         } else {
        //             if (document.getElementById("unit-switch"))
        //                 document.getElementById("unit-switch").checked = false
        //             console.log("API faild with OFF");
        //         }
        // }
    }


    changeModeEcomode = () => {
        console.log("mode", this.state.mode)

        if (this.props.selectedZone.zoneId && this.props.ecoMode) {
            if (this.state.mode === "EcoMode") {
                this.setState({ mode: null })
            } else {
                this.setState({ mode: "EcoMode" })
            }
            this.props.sendAcCommand(
                ecoMode, this.props.guestDetail, "ecoMode",
                this.CommandCallBack, null, this.props.selectedZone.zoneId
            );
        }
    }

    changeFanSpeed = (fanindex, speed, hvacData) => {
        // let speed = null
        let action
        // if (this.props.selectedAC) {
            // if (this.state.currentFanSpeed) {
                this.props.configs.fanSpeedConfig.map( iter => {
                    if(iter.statusValueCode == speed){
                        action = iter.action
                    }
                })
                this.setState({ currentFanSpeed: speed });
                console.log('action**************',action)
                this.props.sendAcCommand(
                    action, null, null, this.props.selectedAC && this.props.selectedAC.HVACIdentifierKey || (hvacData && hvacData.HVACIdentifierKey) || null, this.props.guestDetail,
                    "fanSpeed", this.CommandCallBack , this.props.roomControlSpecificVersion
                );
                //this.VDAApiCall();
            // }
        // }
    }
    goBack = () => {
        let token = localStorage.getItem('GuestJourneySessionToken')
        this.props.getInncomRoomControlData(token , this.props.guestDetail)
        if(this.state.isACSelected && this.props.hvac.length != 1){
            console.log('hvac length = 1')
            this.props.setSelectedAC([])
            this.props.setAcSelected(false)
            this.setState({
                isACSelected: false,
                goBackClicked: true
            })
        } else {
            console.log('hvac length != 1')
            this.props.setSelectedAC([])
            this.props.setAcSelected(false)
            window.history.back();
            this.props.setGoHome(true)
        }

    }

    componentWillUnmount(){
        $('#app-body').css("padding-bottom",this.appBodyPaddBottom);
        $("section#roomTemp").attr("style",`padding-top: ${this.roomTempPaddingTop}`)
        removeScrollDown();

        // Send Analytics
        if(this.props.guestIsLoggedIn){
            let widgetCloseTime = new Date

            let duration = calculateTimeDifference(this.state.widgetLaunchTime, widgetCloseTime, 'second');

            let label = getDefaultAnalyticsLabel({appVersion: this.props.installedAppVersion ? `${this.props.installedAppVersion}(${this.props.installedAppBuildNo})` : ""})
            this.props.sendAnalytics(
                this.props.guestDetail, 
                this.state.widgetName, 
                EXIT, 
                {...label, "layoutTab": this.props.currentHomePage.tabName, "element": "widget", "duration": duration}, 
                0, 
                this.props.guestIsLoggedIn
            );
        }
        //

      }

    // updateState = (mode, currentACTemp, currentACUnit, currentFanSpeed) => {
    //     this.setState({
    //         mode: mode,
    //         currentACTemp: currentACTemp,
    //         currentACUnit: currentACUnit,
    //         currentFanSpeed: currentFanSpeed
    //     })
    // }

    componentDidMount(){

        if(!this.props.guestIsLoggedIn) return
        this.props.setSelectedAC([])
        this.props.setAcSelected(false)
        scrollUpEffect("div.customOverlay",this.props.menuColor);
        this.appBodyPaddBottom = $('#app-body').css("padding-bottom");
        this.roomTempPaddingTop = $("section#roomTemp").css("padding-top");
        scrollToTop();
        $('#app-body').css("padding-bottom","0");
        
        // Send Analytics
        if(this.props.guestIsLoggedIn){
            let label = getDefaultAnalyticsLabel({appVersion: this.props.installedAppVersion ? `${this.props.installedAppVersion}(${this.props.installedAppBuildNo})` : ""})
            this.props.sendAnalytics(
                this.props.guestDetail, 
                this.props.currentWidget.displayName, 
                CLICKED, 
                {...label, "layoutTab": this.props.currentHomePage.tabName, "element": "widget"}, 
                0, 
                this.props.guestIsLoggedIn
            );
        }
        //
    }

    render() {

        scrollDownEffect(null,"section",this.props.menuColor.assetBackgroundSelectorColor,3.6);//backgroundColor:"transparent",

        console.log('this.props.selectedAC',this.props.selectedAC)
        console.log('this.state.fahrenheitMax',this.state.fahrenheitMax, this.state.fahrenheitMin, this.state.celciusMax, this.state.celciusMin)
        return (

            this.props.OnHomeScreen ?
            this.props.fanSpeedConfig.length > 0?
            <div class="room-control-list">
            <div class="room-control-item">
                <div class="room-control-item-label">Ceiling Fan</div>
                <div class="room-control-buttons">
                {this.props.fanSpeedConfig.map((speed, idx) => (
                    <button className={`button-text ${this.state.currentFanSpeed === speed.statusValueCode ? 'active' : ''}`}
                    onClick={()=>this.changeFanSpeed(idx, speed.statusValueCode, this.props.hvacData)} >{speed.label}</button>
                ))}
                </div>
            </div>
        </div>
        : null
        :
            <div
                class="main-container"
                style={/*this.props.selectedZone.zoneId ?
                    {
                        background: `url('${DefaultImage}') center center no-repeat`,
                        backgroundSize: "cover", backgroundAttachment: "fixed", height: "100%"

                    } :
                    {backgroundImage: `linear-gradient(90deg, ${this.props.menuColor.assetBackgroundSelectorColor}66, rgba(255,255,255,0)),url('${DefaultImage}')`
                        background: `${this.props.menuColor.backgroundColor} center center no-repeat`,
                        backgroundSize: "cover", backgroundAttachment: "fixed", height: "100vh"
                    }*/
                    {
                        backgroundSize: "cover", backgroundAttachment: "fixed"
                    }
                
                }
            >{console.log('this.state.currentACTemp', this.state.currentACTemp)}
                <header id = "rc-header" class="inner-pages subpages no-background" style = {{background: this.props.menuColor.assetBackgroundSelectorColor, boxShadow:"unset",border:"none",position:"sticky"}}>
                    <div className = "customOverlay" style = {{transition:"0.3s", position:"absolute",top:"0", left:"0", width: "100%", height:"85px", zIndex:"-1", backgroundColor:"transparent"}}></div>

                    <a onClick={this.goBack} class="button-back"></a>
                    <div class="heading align-center">
                        <div class="splash-brand">
                            <img src={`${CMSPath}${this.props.logo}`} />
                        </div>
                        {/* <p class="bold" style = {{color:"inherit"}}>{ (this.props.hvac.length > 1 && this.props.selectedAC.acLabel ) ? this.props.selectedAC.acLabel : this.props.currentWidget.displayName}</p> */}
                    </div>
                </header>
                {
                    this.props.acSelected ?
                        <section id="roomTemp" class="widgets padding-top-1 padding-left-0 padding-right-0 padding-bottom-0 margin-0 container-bg">

                            <div class="widget-header widget-header-checkin">
                                { this.props.currentWidget.widgetHeaderImageUrl && 
                                    <div class="widget-header-img">
                                        <img src={`${CMSPath}${this.props.currentWidget.widgetHeaderImageUrl}`} alt={this.props.currentWidget.displayName} />
                                    </div>
                                }
                                <div class="widget-header-title">{(this.props.hvac.length > 1 && this.props.selectedAC.acLabel ) ? this.props.selectedAC.acLabel : this.props.currentWidget.displayName}</div>
                            </div>


                            <div class="widgets">
                                <div class="row tile-container" style = {{position:"sticky", top:"85px",backgroundColor:"#fff",zIndex:"9999"}}>
                                    <div class="col col-2 header-container">
                                        <div class="align-center set-temp" style={{ color: "inherit" }}>
                                            <div class="" style={{ color: "inherit", fontSize: "90%" }}>Set Temp</div>
                                            <div class="subtext" style={{ color: "inherit" }}>
                                                {this.props.currentAcTemp === 999 || this.state.powerON === "OFF" ? "--" : this.state.currentACTemp}
                                                {this.state.currentACUnit === "F" ? <><sup>o</sup>F</> : <><sup>o</sup>C</>}
                                            </div>
                                        </div>
                                        { this.props.configs.showCurrentTemperature && 
                                            <div class="align-center" style={{ color: "inherit", fontSize: "90%" }}>
                                                <div class="" style={{ color: this.props.assetFontSelectorColor }}>Room Temp</div>
                                                <div class="subtext" style={{ color: "inherit" }}>
                                                    {this.props.currentRoomTemp === 999 ? "--" : this.state.currentRoomTemp}
                                                    {this.state.currentACUnit === "F" ? <><sup>o</sup>F</> : <><sup>o</sup>C</>}
                                                </div>
                                            </div>
                                        }
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col col-2">
                                        { this.props.selectedAC.powerSwitch && 
                                            <div class="toggle fit-area">
                                                <label class="switch">
                                                    <div class="toggle-label" onClick={this.ACPowerSwitch}>
                                                        <span class="toggle-label-on">On</span>
                                                        <span class="toggle-label-off">Off</span>
                                                    </div>
                                                    <input id="power-switch" type="checkbox" class="unlock" checked={
                                                        this.state.powerON === "ON" ? true : true
                                                    } />
                                                    <span class="slider round focusable"
                                                        style={
                                                            this.state.powerON === "ON" ? {
                                                                background: this.props.menuColor.assetBackgroundSelectorColor
                                                            } : {background: this.props.menuColor.assetBackgroundSelectorColor}
                                                        }
                                                    ></span>
                                                </label>
                                            </div>
                                        }
                                        <div class="toggle fit-area align-right" >{/*style={{ display: "none" }}*/}
                                            <label class="switch" >
                                                <div class="toggle-label unit" onClick={this.ACUnitSwitch}>
                                                    <span class={`${this.state.currentACUnit==="F" ? "toggle-label-on":"toggle-label-off"}`}>F<sup>o</sup></span>
                                                    <span class={`${this.state.currentACUnit==="C" ? "toggle-label-on":"toggle-label-off"}`} style={{color: '#fff'}}>C<sup>o</sup></span>
                                                </div>
                                                <input id="unit-switch" type="checkbox" class="unlock" checked={
                                                        this.state.currentACUnit === "F" ? true : false
                                                    } />
                                                {/* <span class="slider round focusable"
                                                style={
                                                    {
                                                        background: this.props.menuColor.assetBackgroundSelectorColor
                                                    }
                                                } onClick={this.ACUnitSwitch}></span>  */}
                                            </label>
                                        </div>
                                    </div>
                                </div>
                                <div id="tempToggle" class="row padding-bottom-1 padding-right-1 padding-left-1">
                                    <div class="col col-2">

                                        <div class="frame" key={this.state.currentACUnit}>
                                        {(this.props.configs.acRemoteHasButtons ) ?
                                        <div class="acRemoteButtons">
                                                <button  disabled={(this.state.powerON === "ON" ? false : true) || (this.state.currentACUnit == 'C' ? this.state.celciusMax : this.state.fahrenheitMax) <= this.state.currentACTemp } onClick={()=>{ this.onValChange({value: ( Number(this.state.currentACTemp) + 1 ) }, ()=>{this.callApiToSetTemp()} )}}><UpArrow/> </button>
                                                <div class="temp-para">
                                                    <div> 
                                                        <div class="top-text">SET TO</div>
                                                        <div class="degree">{this.state.currentACTemp} <sup>o</sup></div>
                                                        <div class="unit">{this.state.currentACUnit == 'C'?"CELSIUS":"FAHRENHEIT"}</div>
                                                    </div>   
                                                </div>   
                                                <button  disabled={(this.state.powerON === "ON" ? false : true) || (this.state.currentACUnit == 'C' ? this.state.celciusMin : this.state.fahrenheitMin) >= this.state.currentACTemp } onClick={()=>{this.onValChange({value: this.state.currentACTemp - 1 }, ()=>{this.callApiToSetTemp()} )}}> <DownArrow/></button>
                                                <div class="desc">click the arrows to change the room temperature</div>
                                        </div>  
                                        : <>
                                            {/* <div id="slider" class="rslider"></div> */}
                                            <RoundSlider
                                                radius="80"
                                                circleShape="pie"
                                                sliderType="min-range"
                                                update={this.onValChange}
                                                // stop={this.callApiToSetTemp}
                                                change={this.callApiToSetTemp}
                                                startAngle={315}
                                                disabled={this.state.powerON === "ON" ? false : true}
                                                value={this.state.currentACTemp}
                                                valueChange={this.state.currentACTemp}
                                                handleSize="+1"
                                                min= { this.state.currentACUnit == 'C' ? this.state.celciusMin : this.state.fahrenheitMin }
                                                max= { this.state.currentACUnit == 'C' ? this.state.celciusMax : this.state.fahrenheitMax }
                                                editableTooltip={false}
                                            />
                                            <div class="thermostat">
                                                <div class="ring">
                                                    <div class="bottom_overlay"></div>
                                                </div>
                                                <div class="control">
                                                    <div class="temp_room"><span><i class="fas fa-circle-notch"></i></span></div>
                                                </div>
                                            </div>
                                        </>
                                            }
                                        </div>
                                    </div>
                                </div>
                                <div class="row evenrow padding-top-1" style={{ display: "none" }}>
                                    <div class="col col-2">
                                        <div class="toggle fit-area">
                                        </div>
                                        <div class="toggle fit-area align-right">
                                            <label class="switch">
                                                <div class="toggle-label">
                                                    <span class="toggle-label-on">On</span>
                                                    <span class="toggle-label-off">Off</span>
                                                </div>
                                                <input type="checkbox" class="unlock" />
                                                <span class="slider round focusable"></span>
                                            </label>
                                        </div>
                                    </div>
                                </div>
                                { !this.state.mode === "AC_MODE_OFF" ? <div class="row evenrow padding-bottom-1 padding-left-2 padding-right-2">
                                    <div class="col">
                                        <div class="form-controls radio-controls">
                                            <label>Fan Mode</label>
                                            <div class="radio-group">
                                                <label class="radio">
                                                    <input type="radio" onClick={() => this.changeModeEcomode()}
                                                        name="fan-mode" value="Fan Only"
                                                        checked={this.state.mode === "EcoMode" ? true : false} />
                                                    <span class="radio-label" style={this.state.mode === "EcoMode" ? {background:this.props.menuColor.assetBackgroundSelectorColor} : {}}>Eco Mode</span>
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                </div> : null}
                                <div class="row evenrow padding-top-1 padding-bottom-1 padding-left-2 padding-right-2">
                                    <div class="col">
                                        <div class="form-controls radio-controls no-border">
                                            <label>Fan Speed</label>
                                            <div class="radio-group">
                                                {/* <label class="radio">
                                                    <input type="radio" name="fan-speed" value="Auto" onClick={this.changeFanSpeed}
                                                        checked={this.state.fanSpeed === "FAN_SPEED_AUTO" ? true : false} />
                                                    <span class="radio-label"
                                                        style={
                                                            this.state.fanSpeed === "FAN_SPEED_AUTO" ? {
                                                                background: this.props.menuColor.assetBackgroundSelectorColor
                                                            } : null
                                                        }
                                                    >Auto</span>
                                                </label> */}
                                                {this.props.configs.fanSpeedConfig.map((iterator, index) => {
                                                    return(
                                                        <label class="radio">
                                                            <input type="radio" name="fan-speed" value={iterator.label} onClick={()=>this.changeFanSpeed(index, iterator.statusValueCode)}
                                                                checked={this.state.currentFanSpeed === iterator.statusValueCode ? true : false} />
                                                            <span class="radio-label"
                                                                style={
                                                                    this.state.currentFanSpeed === iterator.statusValueCode ? {
                                                                        background: this.props.menuColor.assetBackgroundSelectorColor
                                                                    } : null
                                                                }>{iterator.label}</span>
                                                        </label>
                                                    )})}
                                                {/* <label class="radio">
                                                    <input type="radio" name="fan-speed" value="Medium" onClick={()=>this.changeFanSpeed(2)}
                                                        checked={this.state.currentFanSpeed === "FAN_SPEED_MEDIUM" ? true : false} />
                                                    <span class="radio-label"
                                                        style={
                                                            this.state.currentFanSpeed === "FAN_SPEED_MEDIUM" ? {
                                                                background: this.props.menuColor.assetBackgroundSelectorColor
                                                            } : null
                                                        }
                                                    >Medium</span>
                                                </label>
                                                <label class="radio">
                                                    <input type="radio" name="fan-speed" value="High" onClick={()=>this.changeFanSpeed(3)}
                                                        checked={this.state.currentFanSpeed === "FAN_SPEED_HIGH" ? true : false} />
                                                    <span class="radio-label"
                                                        style={
                                                            this.state.currentFanSpeed === "FAN_SPEED_HIGH" ? {
                                                                background: this.props.menuColor.assetBackgroundSelectorColor
                                                            } : null
                                                        }
                                                    >High</span>
                                                </label> */}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                        : <ACSelector updateState={
                            (mode, currentACTemp, currentRoomTemp, currentACUnit, currentFanSpeed, fahrenheitMin, fahrenheitMax, celciusMin, celciusMax,) => {
                                this.setState({
                                    mode: mode,
                                    currentACTemp: currentACTemp,
                                    currentRoomTemp: currentRoomTemp,
                                    currentACUnit: currentACUnit,
                                    currentFanSpeed: currentFanSpeed,
                                    celciusMax: celciusMax,
                                    celciusMin: celciusMin,
                                    fahrenheitMin: fahrenheitMin,
                                    fahrenheitMax: fahrenheitMax,
                                    isACSelected: true
                                })
                        }}/>
                }
            </ div>
        )
    }
}

const mapStateToProps = state => {
    return {
        guestDetail: state.store.home.guestDetails,
        currentWidget: state.store.sideNavBar.currentWidget,
        logo: state.store.home.currentDuration.brandingInfo ?
            state.store.home.currentDuration.brandingInfo.hotelLogoImageUrl : "",
        selectedZone: state.store.roomControl.selectedZone,
        celciusMax: state.store.InncomRoomControl.celciusMax,
        configs: state.store.InncomRoomControl.configs,
        currentFanSpeed: state.store.InncomRoomControl.currentFanSpeed,
        celciusMin: state.store.InncomRoomControl.celciusMin,
        farenheitMax: state.store.InncomRoomControl.farenheitMax,
        farenheitMin: state.store.InncomRoomControl.farenheitMin,
        currentAcTemp: state.store.InncomRoomControl.currentAcTemp,
        currentRoomTemp: state.store.InncomRoomControl.currentRoomTemp,
        powerSwitch: state.store.InncomRoomControl.selectedAC.powerSwitch,
        ecoMode: state.store.InncomRoomControl.selectedAC.ecoMode,
        seletedIndex: state.store.roomControl.seletedIndex,
        currentWidgets: state.store.sideNavBar.currentWidget,
        zoneCount: state.store.roomControl.zoneCount,
        VDAZoneList: state.store.roomControl.VDAZoneList,
        hvac: state.store.InncomRoomControl.hvac,
        menuColor: state.store.home.MenuColor,
        selectedAC: state.store.InncomRoomControl?
        state.store.InncomRoomControl.selectedAC : [] ,
        acSelected: state.store.acSelected,
        guestIsLoggedIn: state.store2.guestIsLoggedIn,
        installedAppVersion: state.store.installedAppVersion,
        installedAppBuildNo: state.store.installedAppBuildNo,
        currentHomePage: state.store2.currentHomePage,
        roomControlSpecificVersion: state.store.home.clientConfig.webAppWidgetsInfo && state.store.home.clientConfig.webAppWidgetsInfo.appConfigs && state.store.home.clientConfig.webAppWidgetsInfo.appConfigs.roomControlSpecificVersion,
        fanSpeedConfig: state.store.RoomControlZonesWiseData.fanSpeedConfig
    }
}
export default connect(
    mapStateToProps,
    {
        // setRegPage,
        // VDAStatusApi,
        setPowerSwitch,
        sendCommand,
        TempChange,
        sendACCommand,
        setSelectedZone,
        restoreValue,
        setSelectedAC,
        sendAcCommand,
        getInncomRoomControlData,
        setAcSelected,
        setGoHome,
        sendAnalytics,
        setFailScreen
    }
)(AcControl);